import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import { AuthReducer, UserReducer, NotificationReducer } from './reducers/';

const appReducer = combineReducers({
  auth: AuthReducer,
  user: UserReducer,
  notification: NotificationReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'auth_logout') {
    state = undefined;
  }
  return appReducer(state, action);
};

// redux-persist
const persistConfig = {
  key: 'root',
  storage,
  timeout: 0,
  blacklist: ['user', 'notification']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const enhancer =
  process.env.NODE_ENV === 'development'
    ? compose(
        console.tron.createEnhancer(),
        applyMiddleware(thunk)
      )
    : applyMiddleware(thunk);

const store = createStore(persistedReducer, enhancer);

const persistor = persistStore(store);

export { store, persistor };
